import { InputLabel, MenuItem, SelectChangeEvent } from '@mui/material';
import { AxiosResponse } from 'axios';
import { memo, useMemo } from 'react';
import { PmiSelect } from 'shell/components/shared/pmi-select';
import { PmiFormControl } from 'shell/components/shared/pmi-select/pmi-form-control';
import { __OPERATION__MANAGEMENT__ } from 'shell/constants/environment';
import { useHttpFetch } from 'shell/hooks/use-http-fetch';
import { HttpResponseList } from 'shell/models/http-response';
import { ItemVM } from 'shell/view-models/item';

interface MicroServiceListProps {
  value: string;
  disabled?: boolean;
  error?: boolean;
  onChange: (type?: SelectChangeEvent<string>) => void;
  label?: string;
  required?: boolean;
  id?: string;
}

interface MicroservicesBE {
  endpoint: string;
  key: {
    microservizio: string;
  };
}

const MicroServiceListComponent = ({
  value,
  disabled,
  onChange,
  required,
  error,
  label = 'Microservizio esecuzione',
  id = 'microservice',
}: MicroServiceListProps): React.ReactElement => {
  const idTag = `${id}-${label}`;

  const [microservices] = useHttpFetch<HttpResponseList<MicroservicesBE>, Array<ItemVM>>(
    `${__OPERATION__MANAGEMENT__}/microservizi`,
    {
      onBootstrap: true,
      options: {
        errorCatching: true,
        method: 'GET',
        loading: true,
        data: [],
      },
      transformer: (response: AxiosResponse<HttpResponseList<MicroservicesBE>>) => {
        return response.data.payload.list.map((item) => {
          const itemResult: ItemVM = {
            id: item?.key?.microservizio,
            value: item?.endpoint,
          };
          return itemResult;
        });
      },
    }
  );
  const microservicesList = useMemo(() => {
    const data = (microservices?.data as Array<ItemVM>) || [];
    return data;
  }, [microservices.data]);

  return (
    <PmiFormControl fullWidth>
      <InputLabel id={idTag}>{required ? `${label} *` : label}</InputLabel>
      <PmiSelect
        labelId={idTag}
        id={id}
        name={id}
        error={error}
        label={required ? `${label} *` : label}
        disabled={disabled}
        value={value}
        onChange={onChange}
      >
        <MenuItem value="">
          <em>Nessuno</em>
        </MenuItem>
        {microservicesList?.map((status: ItemVM) => (
          <MenuItem key={status.id} value={status.value}>
            {status.id}
          </MenuItem>
        ))}
      </PmiSelect>
    </PmiFormControl>
  );
};

MicroServiceListComponent.displayName = 'Miscroservice list Select';

export const MicroServiceList = memo(MicroServiceListComponent) as typeof MicroServiceListComponent;

export default MicroServiceList;
